// Core
import { useCallback, useState } from 'react';
import {  useQuery } from 'react-query';

// Chakra
import {

  Text,
  useColorModeValue,
  Divider, Button, Flex, Table, Thead, Tr, Td, Tbody
} from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';

// Components
import NotFound from 'views/Dashboard/404.js';
import Pagination from '../../../components/Pagination';
import { useHistory } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa6';
import Card from '../../../components/Card/Card';
import TableSkeleton from '../../../components/TableSkeleton';
import { parseDateTime } from '../../../services/Utils';

const RequestLog = () => {

  const history = useHistory();
  const borderColor = useColorModeValue('blue.50', 'rgba(255, 255, 255, 0.10)');

  const textColor = useColorModeValue('gray.700', 'white');
  const paddingTd = '16px 0 16px 24px';
  const [offset, setOffset] = useState(0);
  const [requestLogs, setRequestLogs] = useState([]);
  const [requestLogsMeta, setRequestLogsMeta] = useState([]);
  const limit = 25;

  const { isFetching, refetch } = useQuery({
    queryKey: ['request-logs', offset],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const params = {
        limit,
        offset,
      };

      const response = await apiService.getRequestLogs(params);
      setRequestLogs(response.data);
      setRequestLogsMeta(response.meta);
      return true;
    },
    retry: false,
    refetchInterval: 30000,
  });


  const handleEditOpen = useCallback(
    (plan) => {
      history.push(`/request-logs/${plan.id}`);
    },
    [history],
  );


  return (
    <>
      <Flex justifyContent="space-between" alignItems="center">
        <Text fontSize='40px' fontStyle='normal' fontWeight='700' color={textColor} mb='0px' className="page-name">Request Logs</Text>
      </Flex>

      <Divider opacity="1" mr="2px" borderColor={borderColor} borderTopWidth="1px" borderBottomWidth="0" mb='32px'/>

      {isFetching ? (
        <TableSkeleton rowCount={5} />
      )
      :requestLogs.length > 0 ? (
        <Card padding={'8px'}>
          <Table color={textColor}>
            <Thead>
              <Tr>
                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    ID
                  </Text>
                </Td>
                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    IP
                  </Text>
                </Td>
                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    User Agent
                  </Text>
                </Td>
                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    Path
                  </Text>
                </Td>
                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    Created At
                  </Text>
                </Td>
                <Td>
                </Td>
              </Tr>
            </Thead>
            <Tbody>
              {requestLogs.map((row) => {
                return (
                  <Tr
                    onClick={() => handleEditOpen(row)}
                    _last={{
                    '& td': {
                      borderBottom: 'none !important',
                    },
                  }} key={row.id} border="unset" className="cursor-tr">
                    <Td verticalAlign="center" p={paddingTd}>
                      <Text variant="text" color={textColor}>
                        {row?.id}
                      </Text>
                    </Td>
                    <Td  verticalAlign="center" p={paddingTd}>
                      <Text variant="text" color={textColor}>
                        {row?.ip}
                      </Text>
                    </Td>
                    <Td verticalAlign="center" p={paddingTd}>
                      <Text variant="text" color={textColor}>
                        {row?.userAgent}
                      </Text>
                    </Td>
                    <Td verticalAlign="center" p={paddingTd}>
                      <Text variant="text" color={textColor}>
                        {row?.path}
                      </Text>
                    </Td>
                    <Td verticalAlign="center" p={paddingTd}>
                      <Text variant="text" color={textColor}>
                        {parseDateTime(row?.createdAt)}
                      </Text>
                    </Td>
                    <Td verticalAlign="center" p={paddingTd}>
                      <Button
                        variant="submit-ms"
                        maxW="140px"
                        w="100%"
                        onClick={handleEditOpen}
                      >
                        View details
                      </Button>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </Card>
      ) : (
        <NotFound text="Not Found" />
      )}

      <Pagination
        meta={requestLogsMeta ?? { limit, offset, total: 0 }}
        isLoadingPage={isFetching}
        currentPage={Math.floor(offset / limit) + 1}
        onPageChange={(newOffset) => setOffset(newOffset)}
      />
      {/*<Attention*/}
      {/*  variant="remove"*/}
      {/*  handle={() => handleDelete(object)}*/}
      {/*  isOpen={isOpen}*/}
      {/*  onOpen={onOpen}*/}
      {/*  onClose={onClose}*/}
      {/*/>*/}
    </>
  );
};

export default RequestLog;
